import { render } from "./CompanySidebar.vue?vue&type=template&id=748617d8&scoped=true"
import script from "./CompanySidebar.vue?vue&type=script&lang=js"
export * from "./CompanySidebar.vue?vue&type=script&lang=js"

import "./CompanySidebar.vue?vue&type=style&index=0&id=748617d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748617d8"]])

export default __exports__